<app-dialog-wrapper>
  <form [formGroup]="dateForm" class="content">
    <p class="content__description">
      You can schedule your order to pickup or get delivery during our working
      hours
    </p>

    <ul class="content__working-hours">
      @for (workingHour of workingHours; track $index) {
        @let workingHoursRange =
          workingHour.startWorkAt + ' - ' + workingHour.endWorkAt;

        <li class="content__working-hours_item working-hour">
          <span class="working-hour__weekdays">
            {{ workingHour.weekdays }}:
          </span>

          <span class="working-hour__hours">
            {{ workingHour.isOpen ? workingHoursRange : 'Closed' }}
          </span>
        </li>
      }
    </ul>

    <div class="content__get-way">
      <h5 class="content__get-way_title">
        How would you like to get this order?
      </h5>

      <app-shipping-method (selectAddress)="onDeliveryMethodChange($event)" />
    </div>

    <div class="content__order-time">
      <h5 class="content__order-time_title">Schedule order time</h5>
      <div class="content__order-time_fields">
        <div class="content__order-time_fields_date-picker">
          <app-date-picker
            formControlName="date"
            [minDate]="currentDate"
            [disabled]="availableScheduleDates().length === 0"
            [availableDates]="availableScheduleDates()"
            (select)="onDateChange($event)"
          />
        </div>

        <div class="content__order-time_fields_time-picker">
          <app-time-picker
            [label]="timeLabel()"
            formControlName="time"
          />
        </div>

        <div class="content__order-time_fields_asap">
          <app-checkbox
            label="As Soon As Possible"
            formControlName="is_asap"
            (valueChange)="onIsAsapChange($event)"
          />
        </div>
      </div>
    </div>
  </form>

  <div footer class="content__actions">
    <app-button
      type="button"
      class="footer__actions_cancel"
      [outline]="true"
      [style]="ButtonStyle.Danger"
      [size]="ButtonSize.Large"
      (click)="closeDialog()"
    >
      Cancel
    </app-button>

    <app-button
      type="submit"
      [size]="ButtonSize.Large"
      (buttonClick)="onSubmit()"
    >
      Schedule Order
    </app-button>
  </div>
</app-dialog-wrapper>
